import {RoadKill} from "./RoadKill";

export interface IWinRatioConfig {
    readonly duration: number;
    readonly type: string;
}

export interface IWinRatiosHighLight {
    readonly normalWin: IWinRatioConfigHighLight[];
    readonly bigWin: IWinRatioConfigHighLight[];
}

export interface IWinRatioConfigHighLight{
    readonly ratio:number;
    readonly text:string;
    readonly duration :number;
}



export interface BigWinLevel {
    from: number;
    to: number;
    duration: number;
    id: number;
    name: string;
}

export class RoadKillWinConfigs {
    public static TINY = "tiny";
    public static SMALL = "small";
    public static MEDIUM = "medium";
    public static LARGE = "large";
    public static BIG_WIN_01 = "bigWin1";
    public static BIG_WIN_02 = "bigWin2";
    public static BIG_WIN_03 = "bigWin3";
    public static BIG_WIN_04 = "bigWin4";
    public static BIG_WIN_05 = "bigWin5";
    public static WIN_RATIOS: IWinRatiosHighLight = {
        normalWin: [
            {
                ratio: 0,
                text: RoadKillWinConfigs.TINY,
                duration: 0,
            },
            {
                ratio: 1.5,
                text: RoadKillWinConfigs.SMALL,
                duration: 0.2,
            },
            {
                ratio: 3,
                text: RoadKillWinConfigs.MEDIUM,
                duration: 0.3,
            },
            {
                ratio: 5,
                text: RoadKillWinConfigs.LARGE,
                duration: 0.7,
            }
        ],
        bigWin: [
            {
                ratio: 15,
                text: RoadKillWinConfigs.BIG_WIN_01,
                duration: 5.333,
            },
            {
                ratio: 25,
                text: RoadKillWinConfigs.BIG_WIN_02,
                duration: 6,
            },
            {
                ratio: 50,
                text: RoadKillWinConfigs.BIG_WIN_03,
                duration: 5.333,
            },
            {
                ratio: 100,
                text: RoadKillWinConfigs.BIG_WIN_04,
                duration: 5.333,
            },
            {
                ratio: 175,
                text: RoadKillWinConfigs.BIG_WIN_05,
                duration: 5.333,
            }
        ]
    };

    public static getWinType(ratio: number): string {
        if (ratio < 1.5) {
            return this.TINY;
        }

        if (ratio < 2.5) {
            return this.SMALL;
        }

        if (ratio < 5) {
            return this.MEDIUM;
        }

        return this.LARGE;
    }

    public static getBigWinLevels(ratio: number) {
        let levels: BigWinLevel[] = []

        if (ratio >= 15) {
            levels.push({
                from: 0,
                to: 25,
                duration: 5.333,
                id: 1,
                name: this.BIG_WIN_01
            })
        }

        if (ratio >= 25) {
            levels.push({
                from: 25,
                to: 50,
                duration: 5.333,
                id: 2,
                name: this.BIG_WIN_02
            })
        }

        if (ratio >= 50) {
            levels.push({
                from: 50,
                to: 100,
                duration: 5.333,
                id: 3,
                name: this.BIG_WIN_03
            })
        }

        if (ratio >= 100) {
            levels.push({
                from: 100,
                to: 175,
                duration: 5.333,
                id: 4,
                name: this.BIG_WIN_04
            })
        }
        if (ratio >= 175) {
            levels.push({
                from: 175,
                to: Number.MAX_VALUE,
                duration: 5.333,
                id: 5,
                name: this.BIG_WIN_05
            })
        }


        levels = this.setLastConfig(ratio, levels);

        return levels;
    }

    public static getWinRatioConfig(ratio: number = RoadKill.model.winRatio): IWinRatioConfig {
        let type: string = RoadKillWinConfigs.getWinType(ratio);
        const duration: number = RoadKillWinConfigs.getCountupDuration(type);
        return {type: type, duration: duration};
    }

    public static getCountupDuration(winType: string): number {
        switch (winType) {
            case RoadKillWinConfigs.LARGE :
                return 0.7;
            case RoadKillWinConfigs.MEDIUM :
                return 0.3;
            case RoadKillWinConfigs.SMALL :
                return 0.2;
            case RoadKillWinConfigs.TINY :
                return 0;
            default :
                return 0;
        }
    }

    private static setLastConfig(winRatio: number, configs: BigWinLevel[]): BigWinLevel[] {
        let lastConfig = configs[configs.length - 1];
        if (lastConfig.from * 1.2 > winRatio && configs.length > 1) {
            configs.pop();
            return RoadKillWinConfigs.setLastConfig(winRatio, configs);
        }

        lastConfig.to = winRatio;
        return configs;
    }
}